import {AfterContentInit, Directive, Inject, OnInit} from "ng-metadata/core";

@Directive({
    selector: '[select-search]',

})

export class PrmSelectSearchAttribute implements AfterContentInit, OnInit{

    constructor(@Inject('$element') private $element: JQuery,
                @Inject('$scope') private $scope: ng.IScope,
                @Inject('$timeout') private $timeout: ng.ITimeoutService) {
    }

    ngOnInit(): any {
    }
    
    ngAfterContentInit(): any {
        this.$timeout(()=>{
            let menu = angular.element(this.findAncestor(this.$element[0], '.md-select-menu-container'));
            // let menu = this.$element.closest('.md-select-menu-container');
            this.$scope.$watch(function focusSearchCheck() {
                return menu.hasClass('md-active') ? menu[0].id : undefined;
            }, (activeMenuId) => {
                if(activeMenuId) {
                    this.$element.focus();
                }
            });

            let topOption = null;
            let upEventListener = (event) => {
                let KEYCODE_UP = 38;
                if(event.keyCode === KEYCODE_UP) {
                    this.$element.focus();
                    event.stopPropagation();
                }
            };

            this.$scope.$watchCollection( () => {
                let mdOptions = menu.find('md-option');
                return  this.getElementArray(mdOptions)
                    .map(function (option) {
                        return option.id;
                    });
            },  (ids) => {
                if(ids.length > 0){
                    let mdOptions = menu.find('md-option');
                    let jTop = mdOptions.eq(0);
                    let top = jTop[0];
                    mdOptions.off('keydown', upEventListener);
                    topOption = top;
                    jTop.on('keydown', upEventListener);
                }
            });

            this.$element.on('keydown', (event) => {
                let KEYCODE_DOWN = 40;
                let KEYCODE_ESCAPE = 27;
                if(event.keyCode === KEYCODE_DOWN) {
                    if(menu.hasClass('md-active'))
                        menu.find('md-option')
                            .eq(0)
                            .focus();
                }
                if (event.keyCode !== KEYCODE_ESCAPE){
                    event.stopPropagation();
                }
            });
        },1000);

    }

    private findAncestor (el, sel) {
        while ((el = el.parentElement) && !((el.matches || el.matchesSelector || el.msMatchesSelector).call(el,sel)));
        return el;
    }

    private getElementArray(angularElement){
        let arr = [];
        for (let i = 0; i < angularElement.length; i++){
            arr.push(angularElement[i]);
        }
        return arr;
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/formBuilder/field/selectSearchAttribute.directive.ts